(function (window) {
  'use strict';

  const activeVariantClass = 'js-product-viewer-variant--active';

  /**
   * Initializes the Carousel.
   *
   * @param {object} carousel the dom element with class .js-product-viewer-carousel
   * @returns {*}
   */
  function initCarousel(carousel) {
    return imagesLoaded(carousel, function () {
      const initializedCarousel = tns({
        container: carousel,
        controlsContainer: carousel.parentNode.querySelector('.js-product-viewer-carousel-controls'),
        navContainer: carousel.closest('.js-product-viewer').querySelector('.js-product-viewer-carousel-nav'),
        loop: false,
        onInit: () => {
          // Forced tabindex="0" to make "prev" and "next" slider buttons keyboard accessible.
          const prevNextControls = carousel.closest('.product-viewer__carousel-wrapper')
            .querySelectorAll('.product-viewer__carousel-control');
          for (let i = 0; i < prevNextControls.length; i++) {
            prevNextControls[i].setAttribute('tabindex', 0);
          }
        }
      });

      if (initializedCarousel) {
        carouselButtonInit(initializedCarousel);
        initializedCarousel.events.on('transitionStart', handleCarouselTransition);
      }
    });
  }

  /**
   * Initializes the buttons for the Carousel slider.
   *
   * @param {object} tiny slider initialized instance of the carousel.
   */
  function carouselButtonInit(carousel) {
    const slide = carousel.getInfo();
    slide.navItems[slide.navCurrentIndex].setAttribute('aria-pressed', 'true')
  }

  /**
   * Handles button actions for the Carousel slider.
   *
   * @param {object} tiny slider initialized instance of the carousel.
   */
  function handleButtonControl(carousel) {
    const currentIndex = carousel.navCurrentIndex;
    const buttons = carousel.navItems;

    for (let i = 0; i < buttons.length; i++) {
      if (i !== currentIndex) {
        buttons[i].setAttribute('aria-pressed', 'false');
      }
    }
    buttons[currentIndex].setAttribute('aria-pressed', 'true')
  }

  function handleCarouselTransition(carousel) {
    let videoContainer = carousel.slideItems[carousel.index].querySelector('.js-slide-video');

    // If slide to which we’re navigating includes a video container,
    // instantiate the player (if it isn’t already) and play the video.
    if (videoContainer) {
      // If player is already instantiated, set its tabindex and play.
      if (window.player) {
        // Restore original tabindex or set it to 0.
        videoContainer.setAttribute('tabindex', videoContainer.getAttribute('data-iframe-tabindex') || 0);
        player.playVideo();

        // Otherwise, instantiate the player (we autoplay on player creation).
      } else {
        createCarouselSlideVideo(videoContainer);
      }

      // If slide to which we’re navigating **does not** include a video
      // container, and there is an instantiated player, pause the video and make
      // the container inaccessible.
    } else {
      if (typeof player !== 'undefined') {
        player.pauseVideo();
        videoContainer = player.getIframe();

        // Store current tabindex to restore it later, if we haven’t already.
        if (!videoContainer.getAttribute('data-iframe-tabindex')) {
          videoContainer.setAttribute('data-iframe-tabindex', videoContainer.getAttribute('tabindex') || 0);
        }
        // Set tabindex=-1 to remove iframe from the tab order.
        videoContainer.setAttribute('tabindex', -1);
      }
    }
    handleButtonControl(carousel);
  }

  function createCarouselSlideVideo(video) {
    const youtubeScriptId = 'youtube-api';
    const youtubeScript = document.getElementById(youtubeScriptId);
    const videoId = video.getAttribute('data-video-id');

    if (youtubeScript === null) {
      const tag = document.createElement('script');
      const firstScript = document.getElementsByTagName('script')[0];

      tag.src = 'https://www.youtube.com/iframe_api';
      tag.id = youtubeScriptId;
      firstScript.parentNode.insertBefore(tag, firstScript);
    }

    window.onYouTubeIframeAPIReady = function () {
      window.player = new window.YT.Player(video, {
        videoId: videoId,
        playerVars: {
          autoplay: 1,
          modestbranding: 1,
          rel: 0
        }
      });
    }
  }

  /**
   * Example of the variant object.
   *
   * @param {string} sku
   * @param {string} name
   */
  function updateCarouselImages(sku, name = '') {
    sku = sku.toLowerCase()
    const carouselImages = document.querySelectorAll('.js-product-viewer-carousel-image');

    // TODO validate if items exists.

    for (let i = 0; i < carouselImages.length; i++) {
      const image = carouselImages[i];
      const newVariantImage = image.getAttribute(`data-${sku}`);
      const newVariantAngle = image.getAttribute('data-angle');
      const newVariantFrame = image.getAttribute('data-frame');

      image.setAttribute('src', newVariantImage);
      image.setAttribute('srcset', newVariantImage + ' 900w, '
        + newVariantImage.slice(0, -3).concat('768') + ' 768w, '
        + newVariantImage.slice(0, -3).concat('420') + ' 420w');
      image.setAttribute('alt', name + " " + newVariantFrame + " " + newVariantAngle + " View");
    }
  }

  function updateProductData(data) {
    // Change information on each component.
    const sku = data.sku;
    // Updates image slider if available.
    updateCarouselImages(data.sku)
    const switchValue = document.querySelectorAll('[data-variant-' + sku + ']');
    const switchEnabled = document.querySelectorAll('[data-variant-' + sku + '-enabled]');
    const switchVisible = document.querySelectorAll('[data-variant-' + sku + '-visible]');

    switchValue.forEach(function (element) {
      element.innerHTML = element.getAttribute('data-variant-' + sku);
    });

    switchEnabled.forEach(function (element) {
      const enabled = element.getAttribute('data-variant-' + sku + '-enabled') === 'true';
      element.setAttribute('aria-disabled', !enabled);
    });

    switchVisible.forEach(function (element) {
      const visible = element.getAttribute('data-variant-' + sku + '-visible') === 'true';
      element.setAttribute('aria-hidden', !visible);
    });
  }

  function init() {
    const angleCarouselWrapper = document.querySelector('.js-product-viewer-carousel');

    // If no carousel exists this script file should not be ran.
    if (!angleCarouselWrapper) {
      return;
    }

    if (!angleCarouselWrapper.classList.contains('js-component-init')) {
      initCarousel(angleCarouselWrapper);
      angleCarouselWrapper.classList.add('js-component-init');
    }
  }

  // Update product data, event wrapper.
  function eventUpdateProductData(sku = '', name = '') {
    if (sku === '') {
      return;
    }
    componentEvents.emitEvent('update-product-data', [{
      sku: sku.toLowerCase(),
      name
    }])
  }

  // Allow application JS to reinitialize any instances added with Ajax, etc.
  if (typeof componentEvents !== 'undefined') {
    componentEvents.on('component-init', init);
    componentEvents.on('update-product-data', updateProductData);
    componentEvents.updateProductData = eventUpdateProductData;
  }

  init();

})(this);
